import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavRouteProps } from "./NavigateRoute";

/**
 * Shared scaffolding for route components feeding NavigateRoute — recomputes
 * NavRouteProps whenever the route match (deps) or the query string changes.
 */
export function useNavProps(compute: (search: string) => NavRouteProps, deps: unknown[]) {
  const { search } = useLocation();
  const [navProps, setNavProps] = useState<NavRouteProps>();

  useEffect(() => {
    setNavProps(compute(search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, search]);

  return navProps;
}
